module.exports = __webpack_public_path__ + "static/img/contect_5.9d326d00.jpg";